import { render, staticRenderFns } from "./registerEntry_tl3.vue?vue&type=template&id=b0de9bb4&scoped=true"
import script from "./registerEntry_tl3.vue?vue&type=script&lang=js"
export * from "./registerEntry_tl3.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/registerEntry_tl3.scss?vue&type=style&index=0&id=b0de9bb4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0de9bb4",
  null
  
)

export default component.exports